import { PayloadAction } from "@reduxjs/toolkit";

import { StationsState } from '../../types';

export const setVisibleStationsDisplay = (
  state: StationsState,
  action: PayloadAction<StationsState['visibleStations']['show']>
) => {
  state.visibleStations.show = action.payload
};
